import 'bootstrap';
import Sharer from 'sharer.js';

import './script.js';